import { useCallback, useEffect, useState } from "react";
import {
	createIntersectionListenerToItems,
	useAddLazyLoadingIntersectionObserver,
} from "./lazy-loading-event-dispatch";

export const INTERACTIVE_LAZY_LOAD_INDEX_EVENT = "[interactive-products]--load";

// Zatím necháme hodnotu fixní, kdyby bylo potřeba v budoucnu
// přednačítat X předmětů, můžeme upravit logiku.
export const LOAD_UP_TO_INDEX = 0;

export const useLazyLoading = ({ enableLazyLoading = false, containers }) => {
	const [loadUpToIndex, setLoadUpToIndex] = useState(LOAD_UP_TO_INDEX);

	const onItemIntersection = useCallback(({ pageIndex }) => {
		setLoadUpToIndex((prevIndex) => {
			// Všechny načtené data zůstávají
			if (pageIndex <= prevIndex) {
				return prevIndex;
			}

			return pageIndex;
		});
	}, []);

	useAddLazyLoadingIntersectionObserver({
		enableLazyLoading,
		containers,
		onItemIntersection,
	});

	return {
		loadUpToIndex: enableLazyLoading ? loadUpToIndex : undefined,
	};
};

export const isOverLazyLoadedIndex = ({ currentIndex, loadUpToIndex }) => {
	const lazyLoadingEnabled = loadUpToIndex !== undefined;

	// Pokud není lazy loading zapnutý, vracíme false
	// nikdy nemůžeme být přes index, který není definován
	if (!lazyLoadingEnabled) {
		return false;
	}

	return currentIndex > loadUpToIndex;
};
